import { Box, IconButton, Typography } from '@mui/material'
import { Checkmark20Regular, Copy20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { copyIcon14Sx } from '../shared/copyIconSx.js'

export function CodeBlockCopyBar({ language, copied, onCopy }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: '10px', py: '6px' }}>
      {language ? (
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase' }}>
          {language}
        </Typography>
      ) : (
        <Box />
      )}
      <Tooltip text={copied ? 'Copied!' : 'Copy code'} placement="top">
        <IconButton className="copy-btn" onClick={onCopy} size="small" sx={{ opacity: 0, transition: 'opacity 0.2s', width: 24, height: 24 }}>
          {copied ? (
            <Box component="span" sx={copyIcon14Sx} aria-hidden>
              <Checkmark20Regular />
            </Box>
          ) : (
            <Box component="span" sx={copyIcon14Sx} aria-hidden>
              <Copy20Regular />
            </Box>
          )}
        </IconButton>
      </Tooltip>
    </Box>
  )
}
